// App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/dashboard/dashboard';
import SignInForm from './pages/signin/signin';
import SignUpForm from './pages/signup/signup';
import { GlobalProvider } from './store/GlobalContext';
import AuthGuard from './authguard';
import ResetPasswordPage from './pages/resetpassword/resetpassword';
import AcceptInvite from './pages/verify/acceptinvite';
import ActivateAccount from './pages/verify/activateaccount';
import { useQuery, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { refreshToken } from './pages/signin/authservice';
import Cookies from 'js-cookie';

const client = new QueryClient();

// This component runs in the background to refresh the token.
const TokenRefresh = () => {
  useQuery({
      queryKey: ['refreshToken'],
      queryFn: refreshToken,
      refetchInterval: 3600000,
      refetchOnWindowFocus: false,
      enabled: Boolean(Cookies.get('refreshToken')),
    });

  return null; 
};

function App() {
  return (
    <GlobalProvider>
      <QueryClientProvider client={client}>
        <TokenRefresh />
        <Router>
          <Routes>
            <Route path="/login" element={<SignInForm />} />
            <Route path="/signup" element={<SignUpForm />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/user/invite/:token" element={<AcceptInvite />} />
            <Route path="/activate" element={<ActivateAccount />} />
            <Route element={<AuthGuard />}>
              <Route path="/*" element={<Dashboard />} />
            </Route>
          </Routes>
        </Router>
      </QueryClientProvider>
    </GlobalProvider>
  );
}

export default App;
